const state = {
  showHeader: true
};

const getters = {
  showHeader: ({ showHeader }) => {
    return showHeader;
  }
};

const actions = {
  async setShowHeader({ commit }, newValue) {
    commit("SAVE_SHOW_HEADER", newValue);
  }
}

const mutations = {
  SAVE_SHOW_HEADER(state, newValue) {
    state.showHeader = newValue;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/main/index.js